export enum SettingMode {
  ADD_TIME = 'addTime',
  DETAIL_TIME = 'timeDetails',
  EDIT_TIME = 'editTime',
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}
export enum AnswerType {
  TEXTBOX = 1,
  PARAGRAPH = 2,
  RADIOBUTTON = 3,
  CHECKBOX = 4,
  DROPDOWN = 5,
  LINEARSCALE = 6,
  FILEUPLOAD = 7,
  DATE = 8,
  TIME = 9,
}

export enum PlanType {
  SAFETYPLAN = 144,
  CRISISPLAN = 145,
}
